import DOMPurify from 'dompurify';
import { ACTIVITIES_DATE_FORMAT_WITH_TIMEZONE } from './dateHelper';
import { formatDateTime } from './functions';

export const sanitize = (str: string): string => {
  return DOMPurify.sanitize(str, { ADD_ATTR: ['target'] });
};

export function boldString(str: string, find: string, className = 'font-bold') {
  if (!find || !str) return str;
  const escapedFind = find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(escapedFind, 'gi');
  return str.replace(re, `<span class="${className}">$&</span>`);
}

export function replaceTokensToDate(
  template: string,
  constants?: Record<string, string>,
): string {
  if (!constants) {
    return template;
  }
  Object.entries(constants).forEach(([key, value]) => {
    const replacement = formatDateTime(
      value,
      ACTIVITIES_DATE_FORMAT_WITH_TIMEZONE,
    );
    const token = `[[${key}]]`;
    template = template.replace(
      new RegExp(token.replace(/[[\]]/g, '\\$&'), 'g'),
      replacement,
    );
  });
  return template;
}

export function formatString(
  templateString: string,
  data: Record<string, string>,
): string {
  return templateString.replace(/\$\{(\w+)\}/g, (match, key) => {
    return key in data ? data[key] : match;
  });
}

export function formatErrorString(
  template: string,
  values: Record<string, string | number>,
): string {
  const regex = /{{\s*([\w_]+)\s*}}/g;
  return template.replace(regex, (match, key) => {
    const hasKey = Object.prototype.hasOwnProperty.call(values, key);
    if (hasKey) {
      return String(values[key]);
    }
    return match;
  });
}
